/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import React, { useEffect, useRef, useState } from 'react';
import Page from 'components/custom/template/Page';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import apiEndpoints from 'constants/apiEndpoints';
import useFetchData from 'hooks/custom/useFetchData';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import TruckerPaymentPaidListColumn from './TruckerPaymentPaidListColumn';
import useShowModal from 'hooks/custom/useShowModal';
import EditBranch from 'views/location/branch/EditBranch';
import CoalChallanPayment from 'views/challan/coal-iron/CoalChallanPayment';
import CreateSettlementModal from 'pages/vendors/trucker/trucker-detail/trucker-detail-tab/payment-tab-items/PendingPayment/CreateSettlementModal';
import fetchData from 'services/fetchData';

const demoData = [
  {
    settlement_id: 'SETT001',
    date: '2025-03-25',
    trucker_name: 'Raj Logistics',
    no_of_challan: 3,
    challan_no: 'CHL12345',
    contact_no: '9876543210',
    tds_amount: 1500.0,
    do_number: 'DO87654',
    payable_amount: 50000.0,
    created_by: 'Admin',
    status: 'Pending',
    approved_by: 'Admin',
    checked_by: 'Supewiser',
    balanceAmt: 2300,
    cashAdvance: 800,
    challanDate: '2025-03-29',
    disQty: 70,
    freightAmt: 3100,
    fuelAmount: 1400,
    loadingExpenses: 300,
    penaltyCharges: 90,
    recQty: 68,
    shortQty: 2,
    totalDeduction: 1000,
    trucker_rate: 600,
    vehicle_number: 'MH17IJ7890'
  },
  {
    settlement_id: 'SETT002',
    date: '2025-03-24',
    trucker_name: 'Sharma Transport',
    no_of_challan: 2,
    challan_no: 'CHL12346',
    contact_no: '9876543211',
    tds_amount: 1800.0,
    do_number: 'DO87655',
    payable_amount: 62000.0,
    created_by: 'User1',

    approved_by: 'Admin',
    checked_by: 'Supewiser',
    status: 'Approved',
    balanceAmt: 2200,
    cashAdvance: 750,
    challanDate: '2025-03-28',
    disQty: 65,
    freightAmt: 2900,
    fuelAmount: 1300,
    loadingExpenses: 270,
    penaltyCharges: 60,
    recQty: 63,
    shortQty: 2,
    totalDeduction: 950,
    trucker_rate: 580,
    vehicle_number: 'MH16GH3456'
  }
];

const TruckerPaymentPaidList = () => {
  const [pageLoading, loadingMessage, handleLoading] = useManagePageLoading();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  // const [attendanceData]=useFetchData(apiEndpoints.attendance.getTodayAttendanceDriver)
  const [filterData, setFilterData] = useState([]);
  const pay = useShowModal();
  const refreshDataRef = useRef(null);

  const handleRefresh = () => {
    if (refreshDataRef.current) {
      refreshDataRef.current();
    }
  };
  const handleRefreshDataRegister = refreshData => {
    refreshDataRef.current = refreshData;
  };
  const createSettlement = useShowModal();

  const handleCheckDetail = async (data, retrieve, viewOnly) => {
    handleLoading(true, 'Fetching Settlement Data');
    const getSettlementData = await fetchData(
      apiEndpoints.trucker.getSettlementDataById(data.settlement_id)
    );
    console.log(
      '🚀 ~ TruckerPaymentPaidList ~ getSettlementData:',
      getSettlementData
    );

    if (getSettlementData.status) {
      handleLoading(false, '');
      const settlementData = {
        retrieve: retrieve || '',
        trucker_id: getSettlementData.data.trucker_id,
        tds_percent: getSettlementData.data.tds_percent,
        challans: getSettlementData.data.challans,
        totalChallanAmount: getSettlementData.data.final_total_amount,
        final_amount: getSettlementData.data.final_total_amount,
        totalTdsCharges: getSettlementData.data.total_tds_charges,
        created_by_name: getSettlementData.data.created_by_name,
        checker_by_name: getSettlementData.data.checker_by_name,
        approved_by_name: getSettlementData.data.approved_by_name,
        paid_by_name: getSettlementData.data.paid_by_name,
        settel_id: data.settlement_id,
        settelment_no: getSettlementData.data.settelment_no,
        settlement_date: getSettlementData.data.settelment_date,
        settlement_status: getSettlementData.data.status,
        viewOnly: viewOnly,
        truckerInformation: {
          truckerName: getSettlementData.data.trucker_name,
          contactNo: getSettlementData.data.trucker_phone,
          panNo: getSettlementData.data.pan_no,
          bankName: getSettlementData.data.trucker_bank_name,
          bankAccountNo: getSettlementData.data.trucker_account_number,
          ifscCode: getSettlementData.data.trucker_bank_ifsc,
          trucker_account_holder_name:
            getSettlementData.data.trucker_account_holder_name
        }
      };
      createSettlement.handleOpenModal(settlementData);
    } else {
      handleLoading(false, '');
      showAlert({
        variant: 'danger',
        message: 'Failed to fetch settlement data'
      });
    }
  };
  const [retrievePayment, setRetrievePayment] = useState(null);

  const handleRetrievePayment = data => {
    // setRetrievePayment(data);
    // setRetrievePay(true);
  };

  return (
    <>
      <Page
        title={'Payment List'}
        tableColumn={{
          column: TruckerPaymentPaidListColumn(
            handleCheckDetail,
            handleRetrievePayment,
            handleLoading
          )
        }}
        exportName="payment list"
        backdrop={{ message: loadingMessage, loading: pageLoading }}
        dataWithDateRange={false}
        // dummyData={demoData}
        dataFormatter={data =>
          data.filter(item =>
            [
              'Second_Approved',
              'Payment_Initiated',
              'Third_Approved',
              'Third_Rejected'
            ].includes(item.status)
          )
        }
        urlEndPoint={apiEndpoints.trucker.getAllSettlementList}
        onRegisterRefresh={handleRefreshDataRegister}
      >
        {createSettlement.isOpen && (
          <CreateSettlementModal
            show={createSettlement.isOpen}
            handleClose={createSettlement.handleCloseModal}
            data={createSettlement.modalData}
            refreshData={handleRefresh}
            handleLoading={handleLoading}
            modalType="payment"
          />
        )}
      </Page>
    </>
  );
};

export default TruckerPaymentPaidList;
